<div class="loading__ctn">
  @if (model.isLoading) {
    <span class="wrap-spinner">
      @if (model.icon) {
        <img [src]="model.icon.value" [alt]="model.icon.alt"
          [class]="model.icon.cssClass">
      } @else {
        <div class="jumping-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      }
      @if (model.text) {
        <span [class]="model.cssClassText">{{model.text.value}}</span>
      }
    </span>
  }
</div>